export const fonts = [
  {label: 'Noto Sans', value: 'Noto+Sans'},
  {label: 'Roboto', value: 'Roboto'},
  {label: 'Open Sans', value: 'Open+Sans'},
  {label: 'Montserrat', value: 'Montserrat'},
  {label: 'Inter', value: 'Inter'},
  {label: 'Lato', value: 'Lato'},
  {label: 'SF Pro Text', value: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'}
];

export const prepareFont = (font = '') =>
  `'${font.split('+').join(' ')}',Roboto, Helvetica, Arial, sans-serif`;
